<div class="row">
  <div class="newPrePayOuter">
    <div class="newPrePayPage">
      <div class="order-view-sec breadcrumbOuter padding-0" id="orderView" [ngClass]="{
    'col-md-9':orderViewtoggle == false,
    'col-md-12':orderViewtoggle == true}">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item active">
              <a href="javascript:void(0)" (click)="navigateToPrePay()">Contracts</a>
              <i class="fas fa-angle-right"></i>
            </li>
            <li class="breadcrumb-item breadcrumbColor" aria-current="page">
              <span>Requests</span>
              <span> # {{contractId}}</span>
            </li>
          </ol>
        </nav>
      </div>

      <div class="prePayTop">
        <div class="row">
          <div class="col-md-12">
            <div *ngIf="error">
              <div class="row">
                <div class="col-md-12">
                  <div class="inline-error" *ngIf="error">
                    <div class="row">
                      <div class="col-md-12 padding-l0">
                        <ol class="error-list">
                          <li class="justify-content-center align-self-center" *ngFor="let err of errorsList">
                            {{err}}
                          </li>
                        </ol>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="search-box-inner material-select withBordr" [class.invalid-field]="prepayContractValidation.Account">
              <ng-select [items]="accountList"
                         [virtualScroll]="true"
                         [(ngModel)]="prePayRequestAccount"
                         bindLabel="accountNameCityState"
                         bindValue="accountNumber"
                         [disabled]="true"
                         placeholder="Select Account"
                         class="custom-select-grower"
                         [searchFn]="accountSearchFn">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-8">
                        <h5 *ngIf="item.accountNumber === item.parentNumber">
                          Parent
                        </h5>
                        <h4 class="name greenColor" [ngOptionHighlight]="search">
                          {{item.accountName}}
                        </h4>
                        <p class="address" [ngOptionHighlight]="search">
                          {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                        </p>
                        <p class="phoneNo" [ngOptionHighlight]="search">
                          {{item.primaryPhoneNumber}}
                        </p>
                        <p class="grower-nos">
                          <span class="grower-gln" [ngOptionHighlight]="search">
                            Account#: {{item.accountNumber}}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                  <div class="ng-option disabled">
                    No data found for "{{searchTerm}}"
                  </div>
                </ng-template>
              </ng-select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="search-box-inner material-select withBordr">
              <ng-select [items]="contractTypeList"
                         [virtualScroll]="true"
                         [(ngModel)]="prePayContractType"
                         bindLabel="item"
                         bindValue="item"
                         placeholder="Select Contract Type"
                         [disabled]="true"
                         [clearable]="false"
                         class="custom-select-grower">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-8">
                        <h4 class="name greenColor" [ngOptionHighlight]="search">
                          {{item}}
                        </h4>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                  <div class="ng-option disabled">
                    No data found for "{{searchTerm}}"
                  </div>
                </ng-template>
              </ng-select>
            </div>
          </div>
        </div>
      </div>

      <div class="preypaytab">
        <div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12 prepayAmntSec" *ngIf="prePayContractType === 'SEED'">
            <div class="secondPt">
              <h5>
                1. Set your desired prepay amount.
              </h5>
              <div>
                <mat-form-field class="wide100" [class.invalid-field]="prepayContractValidation.PrepayAmount">
                  <label>Prepay Amount:</label>
                  <input matInput currencyMask type="text" name="prePayAmount" class="newInput my-2"
                         [(ngModel)]="prePayAmount" autocomplete="off"
                         [options]="{ prefix: '$ ', thousands: ',', decimal: '.', precision: 2, align:'left', allowNegative: false }"
                         maxlength="18" placeholder="$ Enter Amount" (keyup)="validateInput()">
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="col-xl-12 col-lg-12 col-md-12 prepayAmntSec" *ngIf="prePayContractType === 'CPP'">
            <div class="secondPt">
              <h5>1. Set your desired crop protection prepay amount.</h5>

              <div>
                <mat-form-field class="wide100" [class.invalid-field]="prepayContractValidation.CropProtectionPrePayAmount">
                  <label>Crop Protection Prepay Amount:</label>
                  <!--<input matInput type="text" name="prePayAmount"
                   [(ngModel)]="cropProtectionPrePayAmount"
                   app-customcurrency
                   maxlength="11" appDecimalNumber (keyup)="validateInput()">-->
                  <input matInput currencyMask type="text" name="prePayAmount" class="newInput my-2"
                         [(ngModel)]="prePayAmount" autocomplete="off"
                         [options]="{ prefix: '$ ', thousands: ',', decimal: '.', precision: 2, align:'left', allowNegative: false }"
                         maxlength="18" placeholder="$ Enter Amount" (keyup)="validateInput()">
                </mat-form-field>
              </div>
              <div class="row">
                <div class="col-md-2">
                  <label class="labelTxt margin-t20">
                    Payment Type:
                  </label>
                </div>
                <div class="col-md-10">
                  <div class="valueTypeBlock">
                    <mat-radio-group aria-label="Select an option">
                      <mat-radio-button value=" " class="first-radio" [checked]="isManual" (change)="applyTypeChange(' ')">Manual</mat-radio-button>
                      <mat-radio-button value="Y" [checked]='isAuto' (change)="applyTypeChange('Y')">Auto</mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="prepayBtnSec">
      <div class="row">
        <div class="col-md-12">
          <button mat-raised-button class="btns" *ngIf="!accessTypeMode" (click)="placeRequest()">Update Request</button>
          <button mat-raised-button class="btns" color="primary" (click)="navigateToPrePay()">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>
